<template>
  <main>
    <div>
      <b-row class="auth-inner mainrowtxt justify-content-center">
          <!-- Quote -->
          <b-col
          sm="12"
          md="6"
          lg="6"
          xl="5"
          class="d-flex align-items-center border-5"
          >
          <b-col
              sm="12"
              class="mx-auto"
          >
              <b-card-title
              class="mb-1 font-weight-bold"
              title-tag="h2"
              >
              <h3 class="sft_title">{{$t('message.main_sft_title')}}</h3>
              <span class="secondary_c">{{$t('message.main_sft_text')}}</span>
              </b-card-title>

              <!-- quote,pay -->
              <div class="mt-2">
                <b-button
                :to="route('quotation')"
                type="button"
                variant="secondary"
                block
                >
                {{$t('message.get_quote')}}
                </b-button>
                <div class="divider my-2">
                  <div class="divider-text">
                    {{$t('message.or')}}
                  </div>
                </div>
                <b-button
                  :to="route('payments')"
                  type="button"
                  variant="success"
                  block
                >
                {{$t('message.payment_btn')}}
                </b-button>
              </div>
              
          </b-col>
          </b-col>
          <!-- Quote-->

          <!-- Right Img-->
          <b-col
          sm="12"
          md="6"
          lg="6"
          xl="7"
          class="d-none d-md-flex align-items-center"
          >
          <div class="w-100 d-md-flex align-items-center justify-content-center">
              <b-img
              fluid
              :src="imgUrl"
              alt="Safetravel"
              />
          </div>
          </b-col>
          <!-- Right Img-->
      </b-row>
      <b-row>
          <b-col
          cols="12"
          class="text-center pt-4 pb-1"
          >
            <h2 class="tailormade_title">{{$t('message.tailor_made')}}</h2>
          </b-col>
          <!-- Products Info Img-->
          <b-col
          md="6"
          lg="6"
          class="d-none d-lg-flex pt-2"
          >
              <div class="w-100 d-lg-flex align-items-start justify-content-center stickytopparent">
                  <b-img
                  fluid
                  :src="travelImg"
                  alt="Safetravel"
                  class="stickytop"
                  />
              </div>
          </b-col>
          <!-- Products Info Img-->

          <!-- Products Info Text-->
          <b-col
          lg="6"
          class="align-items-center bg-white pt-2 border-5 tailormadecolor"
          >
              <div>
                  <h2 class="tailormade_txt">{{$t('message.based_needs')}}</h2>
                  <ul class="listtypedlist">
                      <li>{{$t('message.for_travel_agencies_and_tour_operators')}}</li>
                        <ul>
                          <li>{{$t('message.t_a_point_1')}}</li>
                          <li>{{$t('message.t_a_point_2')}}</li>
                        </ul>
                      <li>{{$t('message.for_insurance_brokers')}}
                        <ul>
                          <li>{{$t('message.i_b_point_1')}}</li>
                          <li>{{$t('message.i_b_point_2')}}</li>
                        </ul>
                      </li>
                      <li>{{$t('message.for_booking_platforms_and_resellers')}}
                        <ul>
                          <li>{{$t('message.b_p_point_1')}}</li>
                          <li>{{$t('message.b_p_point_2')}}</li>
                        </ul>
                      </li>
                      <li>{{$t('message.for_mobility_driven_industries')}}
                        <ul>
                          <li>{{$t('message.m_d_point_1')}}</li>
                          <li>{{$t('message.m_d_point_2')}}</li>
                        </ul>
                      </li>
                  </ul>
              </div>
              <div>
                  <h2 class="tailormade_txt">{{$t('message.plc_trip')}}</h2>
                  <ul class="checklisttype mb-0">
                      <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" /><span class="spanboldchecklist">Single trip:</span> {{$t('message.single_trp_text')}}</li>
                      <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" /><span class="spanboldchecklist">Annual Multi-Trip:</span> {{$t('message.annual_trp_text')}}</li>
                      <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" /><span class="spanboldchecklist">Students Insurance:</span> {{$t('message.student_trp_text')}}</li>
                      <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" /><span class="spanboldchecklist">Business Travel Insurance:</span> {{$t('message.bussiness_trp_text')}}</li>
                      <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" /><span class="spanboldchecklist">{{$t('message.covid_cover')}}</span>
                          <span class="d-block">{{$t('message.covid_incld')}}</span>
                          <span class="d-block mt-1">{{$t('message.offered_exclusively_sompo')}}</span>
                      </li>
                  </ul>
              </div>
              <div class="text-center mb-1">
                <b-button
                  :to="route('products')"
                  type="button"
                  variant="primary"
                  >
                  {{$t('message.check_our_products')}}
                  </b-button>
              </div>
              <!-- test -->
              <div>
                <!-- Affiliate & ERP Banner -->
                <b-row v-if="!hasAgent" class="mt-2">
                  <b-col cols="12">
                    <h2 class="tailormade_txt">{{$t('message.experly_structured')}}</h2>
                  </b-col>
                  <b-col cols="12" md="6" class="mb-2">
                    <div class="affiliate-banner">
                      <div>
                        <strong>{{$t('message.ownaude')}}</strong>
                        <p class="mb-0 mt-1">{{$t('message.getperstoken')}}</p>
                      </div>
                      <b-button :to="route('affiliate')" variant="outline-primary" size="sm" class="mt-1">
                        {{$t('message.joinaffpr')}} →
                      </b-button>
                    </div>
                  </b-col>
                  <b-col cols="12" md="6" class="mb-2">
                    <div class="affiliate-banner">
                      <div>
                        <strong>{{$t('message.areyoua_buss')}}</strong>
                        <p class="mb-0 mt-1">{{$t('message.managesls')}}</p>
                      </div>
                      <b-button href="https://erp.safetravel.today" target="_blank" variant="outline-success" size="sm" class="mt-1">
                        {{$t('message.joinasbsnpartner')}} →
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <!-- test -->
          </b-col>
          <!-- Products Info Text-->
      </b-row>
      <b-row>
        <b-col lg="12">
          <div class="mb-4 mt-4 dashed-background">
            <h2 class="text-center safetravelpalletedeepgreen mb-1">{{$t('message.pop_dest')}}</h2>
            <b-row class="populardestsrow" @click="$router.push(route('quotation'))">
              <b-col xl="6" lg="6" md="6" sm="6">
                <b-card 
                  title="Paris, FRA"
                  :img-src="imgFrance"
                  img-alt="France"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 19.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="6" lg="6" md="6" sm="6">
                <b-card
                  title="London, GBR"
                  :img-src="imgUK"
                  img-alt="United Kingdom"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 35.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="6" lg="6" md="6" sm="6">
                <b-card
                  title="Rome, ITA"
                  :img-src="imgItaly"
                  img-alt="Italy"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 28.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="3" lg="6" md="6" sm="6">
                <b-card
                  title="Alpes, AUT"
                  :img-src="imgAustria"
                  img-alt="Austria"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 19.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="3" lg="6" md="6" sm="6">
                <b-card
                  title="Barcelona, ESP"
                  :img-src="imgSpain"
                  img-alt="Spain"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 12.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="3" lg="6" md="6" sm="6">
                <b-card
                  title="Budapest, HUN"
                  :img-src="imgHungary"
                  img-alt="Hungary"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 35.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="3" lg="6" md="6" sm="6">
                <b-card
                  title="Amsterdam, NLD"
                  :img-src="imgHolland"
                  img-alt="Holland"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 23.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="6" lg="6" md="6" sm="6">
                <b-card
                  title="Santorini, GRC"
                  :img-src="imgGreece"
                  img-alt="Greece"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 5.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="3" lg="6" md="6" sm="6">
                <b-card
                  title="New Delhi, IND"
                  :img-src="imgIndia"
                  img-alt="India"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 23.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="3" lg="6" md="6" sm="6">
                <b-card
                  title="Beijing, CHN"
                  :img-src="imgChina"
                  img-alt="China"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 66.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="3" lg="6" md="6" sm="6">
                <b-card
                  title="Male, MDV"
                  :img-src="imgMaldives"
                  img-alt="Maldives"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 54.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col xl="3" lg="6" md="6" sm="6">
                <b-card
                  title="Bridgetown, BRB"
                  :img-src="imgBarbados"
                  img-alt="Barbados"
                  img-top
                  img-height="250px"
                >
                  <b-card-text>
                    <h3>{{$t('message.from_price')}} 53.99€</h3>
                  </b-card-text>
                </b-card>
              </b-col>
  
            </b-row>
            <div class="blurred"></div>
          </div>
        </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
// import Locale from '../components/Locale.vue'
import {
  BRow, BCol, BCardText, BCardTitle, BImg, BButton, BCard
} from 'bootstrap-vue'
import store from '@/store/index'
import { agentRoutesMixin } from '@/products'

export default {
  components: {
    BRow,
    BCol,
    BCardText,
    BCardTitle,
    BImg,
    BButton,
    BCard,
    // Locale
  },
  metaInfo: {
    title: 'Plan Safe Trips | Safetravel.today - Making Travel Insurance Easy',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'description', content: 'Plan safe trips with Safetravel.today, the ultimate travel insurance app for secure travel planning.' },
      { name: 'keywords', content: 'travel insurance app, safe travel, Safetravel.today, secure travel planning' },
      { property: 'og:title', content: 'Safetravel.today - Easy Travel Insurance App' },
      { property: 'og:description', content: 'Plan safe trips with our user-friendly travel insurance app.' },
      { property: 'og:image', content: 'https://safetravel.today/images/og-image.png' },
      { property: 'og:type', content: 'website' },
      { name: 'robots', content: 'index, follow' },
    ],
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Safetravel.today',
          url: 'https://safetravel.today',
          logo: 'https://safetravel.today/logo.png',
          sameAs: [
            'https://www.facebook.com/safetraveltoday',
            'https://www.linkedin.com/company/safe-travel',
            'https://x.com/safetraveltoday'
          ],
          description: 'Safetravel.today is a travel insurance company offering secure, flexible, and affordable coverage for safe journeys worldwide.'
        },
      },
    ],
  },
  mixins: [agentRoutesMixin],
  data() {
    return {
      sideImg: require('@/assets/images/pages/login-v2-dark.svg'),
      travelImg: require('@/assets/images/pages/clipartproducts.png'),
      imgFrance: require('@/assets/images/destinations/france.jpg'),
      imgUK: require('@/assets/images/destinations/united_kingdom.jpg'),
      imgItaly: require('@/assets/images/destinations/italy.jpg'),
      imgAustria: require('@/assets/images/destinations/austria.jpg'),
      imgBarbados: require('@/assets/images/destinations/barbados.jpg'),
      imgChina: require('@/assets/images/destinations/china.jpg'),
      imgSpain: require('@/assets/images/destinations/spain.jpg'),
      imgHungary: require('@/assets/images/destinations/hungarynew.jpg'),
      imgHolland: require('@/assets/images/destinations/netherlands.jpg'),
      imgGreece: require('@/assets/images/destinations/greece.jpg'),
      imgIndia: require('@/assets/images/destinations/india.jpg'),
      imgMaldives: require('@/assets/images/destinations/maldives.jpg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.populardestsrow img {
  object-fit: cover;
}
.populardestsrow .card {
  box-shadow: 0px 2px 10px #888888;
  cursor:pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.populardestsrow .card:hover {
  transform: scale(1.02);
  box-shadow: 0px 6px 20px #888888;
}
.populardestsrow .card > .card-body > .card-title, .populardestsrow .card > .card-body > .card-text > h3 {
  color: var(--foreground-color);
}
.populardestsrow .card > .card-body > .card-text > h3 {
  font-style: oblique;
  font-weight:400;
}
.img_logo {
    display: block;
    margin: 0 auto;
    max-width: 700px;
    width: 80%;
    height: auto;
}
.secondary_c {
    color: var(--foreground-color);
    font-weight: 500;
    font-size: 16px;
    .dark-layout & {
      color: var(--accent2-color);
    }
}
.sft_title {
    color: var(--accent3-color);
    font-weight: 600;
    font-size: 2em;
}
.signintxt {
    color: var(--foreground-color);
}
.tailormadecolor {
  font-weight:500;
  color: var(--foreground-color);
  .dark-layout & {
    color: var(--foreground-color);
  }
}
.tailormade_txt {
    color: var(--accent1-color);
    padding-bottom: 10px;
    font-size: 1.5rem;
    font-weight: 600;
    display: block;
    .dark-layout & {
      color: var(--accent1-color);
    }
}
.tailormade_title, .safetravelpalletedeepgreen {
    color: var(--accent1-color);
    position: relative;
    padding-bottom: 10px;
    font-size: 2.3rem;
    font-weight: 600;
}
.safetravelpalletedeepgreen {
      text-shadow: 
        1px 1px 0px rgba($secondary, 0.5),
        2px 2px 0px rgba($secondary, 0.3),
        3px 3px 0px rgba($secondary, 0.15);
    letter-spacing: 0.05em;
}
.tailormade_title::before {
    content: "";
    position: absolute;
    bottom: 0;
    border-radius: 4px;
    margin-left: 5px;
    width: 80px;
    height: 4px;
    background: var(--foreground-color);
}
.listtypedlist {
    list-style-type: disc;
    padding-left: 1rem;
    padding-bottom: 0.75em;
}
.listtypedlist li {
    padding-left: 0.5em;
}
.listtypedlist li::marker {
    color: var(--accent3-color);
    content: "►";
}
.checklisttype {
    list-style: none;
    padding: 0;
}
.checklisttype li {
    padding-left: 1.3em;
    padding-bottom: 1em;
}
.dbcheck {
    margin-left: -1.3em;
    width: 1.3em;
    color: var(--accent3-color);
}
.spanboldchecklist {
    color: var(--accent1-color);
    font-weight: 600;
}
.stickytop {
    position: sticky;
    top: 0;
    padding-top:100px;
}
.stickytopparent {
    margin-top:-100px;
}
.border-5 {
  border-radius: 10px;
}
.destinationimg {
  height: 250px;
}
@media screen and (max-width: 992px) {
  .mainrowtxt {
    margin-top:25px;
  }
}
</style>
